'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var handlePositionStyle = function handlePositionStyle(position) {
  return {
    position: 'absolute',
    top: 0,
    left: position === 'LEFT' ? 0 : 20
  };
};

var HorizontalSwitch = function HorizontalSwitch(_ref) {
  var position = _ref.position,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'button',
    {
      className: 'quiver-horizontal-switch',
      onClick: onClick
    },
    _react2.default.createElement('div', { className: 'quiver-horizontal-switch__slider' }),
    _react2.default.createElement('div', { className: 'quiver-horizontal-switch__handle', style: handlePositionStyle(position) })
  );
};

HorizontalSwitch.propTypes = {
  position: _propTypes2.default.oneOf(['LEFT', 'RIGHT']),
  onClick: _propTypes2.default.func
};

HorizontalSwitch.defaultProps = {
  position: 'LEFT',
  onClick: null
};

exports.default = HorizontalSwitch;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/HorizontalSwitch/HorizontalSwitch.js
// module id = 590
// module chunks = 11